<template>
    <div>

        <b-modal id="create-or-update-location" size="lg" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <firm-create-or-update-location :editing="editing" v-model="location" :countries="countries" :location-types="locationTypes"></firm-create-or-update-location>
            <template #modal-footer>
                <v-executer :editing="editing" :loading="loading" :action="createOrUpdate"></v-executer>
            </template>
        </b-modal>

        <v-table    ref="table"
                    pagination="server"
                    :add-callback="createNew"
                    name="firm-location-table"
                    :items-provider="provider"
                    search
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </div>
</template>

<script>
import FirmOperationsApi from '@/api/firm-operations'
import SystemDataApi from '@/api/system-data'
import FirmCreateOrUpdateLocation from '@/views/firm-operations/firm/components/FirmCreateOrUpdateLocation'
export default {
    components:{
        FirmCreateOrUpdateLocation
    },
    props:{
        firm:Object,
    },
    data(){
        return{
            fields:[
                { name:"Lokasyon Adı",key:"LocationName",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Lokasyon Tipi",key:"LocationTypeName",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'LocationType.Name'},
                { name:"Ülke",key:"CountryName",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'Country.Name'},
                { name:"İl",key:"ProvinceName",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'Province.Name'},
                { name:"İlçe",key:"DistrictName",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'District.Name'},
                { name:"Mahalle",key:"NeighborhoodName",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'Neighborhood.Name'},
                { name:"Sokak",key:"StreetName",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'Street.Name'},
                { name:"Bina No",key:"BuildingNumber",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Kapı No",key:"DoorNumber",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Kat",key:"Floor",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Posta Kodu",key:"PostalCode",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Enlem",key:"Xcoordinate",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Boylam",key:"Ycoordinate",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Adres",key:"Address",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Fatura Adresi",key:"IsInvoiceAddress",tdClass:"text-nowrap", thClass:"w-5",sortable:true},
                { name:"Fatura Başlığı",key:"InvoiceTitle",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Posta Adresi",key:"PostalAddress",tdClass:"text-nowrap", thClass:"w-5",sortable:true},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"primary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            loading:false,
            countries:[],
            locationTypes:[],
            location:{
                FirmId:this.firm.Id,
                Id:null,
                LocationName:null,
                LocationType:null,
                LocationTypeId:null,
                Country:null,
                CountryId:null,
                Province:null,
                ProvinceId:null,
                District:null,
                DistrictId:null,
                Neighborhood:null,
                NeighborhoodId:null,
                Street:null,
                StreetId:null,
                BuildingNumber:null,
                DoorNumber:null,
                Xcoordinate:null,
                Ycoordinate:null,
                Address:null,
                PostalCode:null,
                Floor:null,
                IsInvoiceAddress:false,
                InvoiceTitle:null
            }
        }
    },
    mounted(){
        this.getCountries()
        this.getLocationTypes()
    },
    methods:{
        clearForm(){
            this.editing = false
            this.location.FirmLocationDummyId=null
            this.location.LocationName=null
            this.location.LocationType=null
            this.location.LocationTypeId=null
            this.location.Province=null
            this.location.ProvinceId=null
            this.location.District=null
            this.location.DistrictId=null
            this.location.Neighborhood=null
            this.location.NeighborhoodId=null
            this.location.Street=null
            this.location.StreetId=null
            this.location.BuildingNumber=null
            this.location.DoorNumber=null
            this.location.Xcoordinate=null
            this.location.Ycoordinate=null
            this.location.Address=null
            this.location.PostalCode=null
            this.location.Floor=null
            this.location.InvoiceTitle = null
            this.location.IsInvoiceAddress = null
        },
        createNew(){
            this.clearForm()
            this.$showModal("create-or-update-location")
        },
        getLocationTypes(){
            SystemDataApi.LocationType().then(response => {
                this.locationTypes = response.data.Data
            })
        },
        getCountries(){
            SystemDataApi.Country().then(res=>{
                this.countries = res.data.Data
            })
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.$refs.table.rowLoading(true)
            FirmOperationsApi.Location.Get(item.Id).then((res)=>{
                this.location.Id = res.data.Data.Id
                this.location.LocationName = res.data.Data.LocationName
                this.location.LocationTypeId = res.data.Data.LocationTypeId
                this.location.CountryId = res.data.Data.CountryId
                this.location.ProvinceId = res.data.Data.ProvinceId
                this.location.DistrictId = res.data.Data.DistrictId
                this.location.NeighborhoodId = res.data.Data.NeighborhoodId
                this.location.StreetId = res.data.Data.StreetId
                this.location.BuildingNumber = res.data.Data.BuildingNumber
                this.location.DoorNumber = res.data.Data.DoorNumber
                this.location.Xcoordinate = res.data.Data.Xcoordinate
                this.location.Ycoordinate = res.data.Data.Ycoordinate
                this.location.Address = res.data.Data.Address
                this.location.PostalCode = res.data.Data.PostalCode
                this.location.PostalAddress = res.data.Data.PostalAddress
                this.location.Floor = res.data.Data.Floor
                this.location.IsInvoiceAddress = res.data.Data.IsInvoiceAddress
                this.location.InvoiceTitle = res.data.Data.InvoiceTitle
                this.$refs.table.rowLoading(false)
                this.$showModal("create-or-update-location")
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        createOrUpdate(){
            this.loading = true
            FirmOperationsApi.Location.CreateOrUpdate(this.editing,this.location).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal("create-or-update-location")
                    this.$emit('refresh')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${this.firm.Name} firmasına ait ${item.LocationName} isimli lokasyonu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    FirmOperationsApi.Location.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                            this.$emit('refresh')
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        provider(data){
            return FirmOperationsApi.Location.Table({PaginationRequestModel:data,FirmId:this.firm.Id})
        },
        
    }
}
</script>

<style>

</style>